/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductCategory } from './ProductCategory';
import {
    ProductCategoryFromJSON,
    ProductCategoryFromJSONTyped,
    ProductCategoryToJSON,
} from './ProductCategory';
import type { ProductType } from './ProductType';
import {
    ProductTypeFromJSON,
    ProductTypeFromJSONTyped,
    ProductTypeToJSON,
} from './ProductType';

/**
 * 
 * @export
 * @interface SpecificActiveProduct
 */
export interface SpecificActiveProduct {
    /**
     * 
     * @type {string}
     * @memberof SpecificActiveProduct
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificActiveProduct
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificActiveProduct
     */
    canonicalId?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof SpecificActiveProduct
     */
    productType?: ProductType;
    /**
     * 
     * @type {ProductCategory}
     * @memberof SpecificActiveProduct
     */
    productCategory?: ProductCategory;
}

/**
 * Check if a given object implements the SpecificActiveProduct interface.
 */
export function instanceOfSpecificActiveProduct(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SpecificActiveProductFromJSON(json: any): SpecificActiveProduct {
    return SpecificActiveProductFromJSONTyped(json, false);
}

export function SpecificActiveProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecificActiveProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'canonicalId': !exists(json, 'canonicalId') ? undefined : json['canonicalId'],
        'productType': !exists(json, 'productType') ? undefined : ProductTypeFromJSON(json['productType']),
        'productCategory': !exists(json, 'productCategory') ? undefined : ProductCategoryFromJSON(json['productCategory']),
    };
}

export function SpecificActiveProductToJSON(value?: SpecificActiveProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'canonicalId': value.canonicalId,
        'productType': ProductTypeToJSON(value.productType),
        'productCategory': ProductCategoryToJSON(value.productCategory),
    };
}

